import { render, staticRenderFns } from "./add-progress-table.vue?vue&type=template&id=4fbf7888&scoped=true&"
import script from "./add-progress-table.vue?vue&type=script&lang=js&"
export * from "./add-progress-table.vue?vue&type=script&lang=js&"
import style0 from "./add-progress-table.vue?vue&type=style&index=0&id=4fbf7888&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbf7888",
  null
  
)

export default component.exports